import { AppBar, Box, Toolbar } from "@mui/material";
import UserInfo from "../../Avatar/HeaderAvatarInfo/HeaderAvatarInfo";
import ScopesDropdown from "../../Dropdowns/ScopesDropdown";
import classes from "./MainHeader.module.css";

export const Header = () => {
  return (
    <div className={classes.header}>
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.toolBar}>
          <Box className={classes.box}>
            <ScopesDropdown/>
          </Box>
          <Box>
            <UserInfo/>
          </Box>
        </Toolbar>
      </AppBar>
    </div>
  );
};
